export default __webpack_public_path__ + "static/media/shop.b8cc1e31.svg";